module.exports = __webpack_public_path__ + "static/Abacus Bewerbercockpit-9fc08df8aeb4fa341d445579c1d5a0b7.png";